import React, {useState, useEffect, useContext} from 'react';
import { getEmptyImage } from "react-dnd-html5-backend";
import { useDrag, DragSourceMonitor } from "react-dnd";
import { useLocation } from "react-router-dom";
import {IProps} from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import { PreviewForm } from '@assets/icons/previewForm';
import OptionIcon from '@assets/icons/optionIcon';
import FavoriteDesignIcon from '@assets/icons/favoriteDesignIcon';
import IconButton from '@components/IconButton';
import PreviewComponentOptions from '../PreviewComponentOptions';
//import EditDesign from '../EditDesign';
import PreviewGrid from '../PreviewGrid';
import { BrandsContext } from '@utils/DOIgnition/BrandsContext';
import { IDSConfig, IBrandDefinition } from '@state/dsconfig/types';
import { useSelector } from 'react-redux';
import selectors from '@state/selectors';

const PreviewComponent:React.FC<IProps> = (props) => {

  const dsConfig: IDSConfig = useSelector(selectors.dsConfig.getDSConfig);
  const brandsContext = useContext(BrandsContext);

  const [selected, setSelected] = useState( false ); 
  const [openOptions, setOpenOptions] = useState(false);
  const [coordinates, setCoordinates] = useState({x: 0, y: 0});
  const [openEdit, setOpenEdit] = useState(false);
  const [oem, setOem] = useState<IBrandDefinition| undefined>(undefined);
  let location = useLocation();
  
  const { item } = props;
  let left=0, top =0;

  useEffect(()=>{
    let oemfind = dsConfig?.brands?.find(f=> f.name == props.item.name)
    if (oemfind)
      setOem(oemfind)
  },[dsConfig])

  useEffect(() => {
    if (props.selected!==undefined) setSelected(props.selected);
  }, [props.selected])

  const handleMouseSizes = (e: any) => {
    if (openOptions === false) setCoordinates({x: e.clientX, y: e.clientY});
  }

  const renderData = () => {
    var logos =  props.item.logos?props.item.logos.length:0;
    var colors = props.item.colors?props.item.colors.length:0;
    var fonts = props.item.fonts?.length?props.item.fonts.filter((item: any) => (item.status === 'ACTIVE')).length:0;
    var vehicles = props.item.vehicles?props.item.vehicles.length:0;
    var backgrounds = props.item.backgrounds?props.item.backgrounds.length:0;
    var stocks = props.item.stocks?props.item.stocks.length:0;     
    return (
      <>            
        {`${colors} colors, ${logos} logos, ${fonts} fonts, ${vehicles} vehicles, ${backgrounds} backgrounds, ${stocks} stocks`}              
      </>
    )
  }

  const renderCornerSize = () => {
    var sizes = "No sizes";
    if (props.item.tags?.formats && props.item.tags.formats.length) {
      if (props.item.tags.formats.length === 1) {
        props.item.tags.formats.map((format: any) => {
          sizes = `${format.width}x${format.height}`;
        })
      } else {
        sizes = `${props.item.tags.formats.length} sizes`;
      }
    }
    return sizes;
  }

  const renderCustomTags = () => {
    var customTags = "";
    if (props.item.tags?.customTags && props.item.tags?.customTags.length > 0) {
      customTags = props.item.tags?.customTags.join(' - ');
    } else if (props.item.tags?.platform && props.item.tags?.oem) {
      customTags = `${props.item.tags.platform} - ${props.item.tags.oem}`
    }
    return customTags;
  }

  const handleOpenOptions = (e: any) => {
    e.stopPropagation();
    setOpenOptions(!openOptions);
    setCoordinates({x: e.clientX, y: e.clientY});
  }

  const handleActions = (action: string) => {
    if (action==="NAMEFOLDER") setOpenEdit(true);
    else if (action==="EDITBRAND" && brandsContext) brandsContext.setBrandDetail({open:true, brand: props.item});
    else if (props.onActions) props.onActions(props.item, action);
  }

  const handleEdit = (action: string, folder:number) => {
    if (props.onActions) props.onActions(props.item, action, folder);
  }

  const handleClick = (e: any) => {    
    if (brandsContext) brandsContext.setBrandDetail({open:true, brand: props.item});  
  }

  return (
    <S.Root
      id={props.id ? props.id : `preview-component-${props.item?.id}`}      
    >
      <S.MainContainer >
        <S.BoxContainer onClick={(e) => handleClick(e)}>
          <S.PreviewContainer selected={selected}>           
            <S.PreviewContent>
              {
                dsConfig &&
              <PreviewGrid
                brand={props.item}
                oem={oem}
              />
              }
            </S.PreviewContent>
            {
              props.showMetadata === true && !selected &&
              <S.MetaDataContainer>
                <S.MetaData>
                  <S.MetaDataOptionIconContainer>
                    <IconButton
                      containerStyles={{transform: 'scale(0.7)'}}
                      action={handleOpenOptions}
                    >
                      <OptionIcon
                        style={{fillColor: C.WHITE}}
                      />
                    </IconButton>
                  </S.MetaDataOptionIconContainer>
                  <S.MetaDataTitle>
                    
                  </S.MetaDataTitle>
                  <S.MetaDataCustomTags>
                    {renderCustomTags()}
                  </S.MetaDataCustomTags>
                </S.MetaData>
              </S.MetaDataContainer>
            }
          </S.PreviewContainer>
        </S.BoxContainer>
        <S.BottomContainer>
          <S.Title>
            {props.item.name} {props.item.oem?`(OEM)`:``}            
          </S.Title>
          <S.Subtitle
            onMouseEnter={handleMouseSizes}
          >
            {renderData()}
          </S.Subtitle>
        </S.BottomContainer>
      </S.MainContainer>
      {
        openOptions &&
        <PreviewComponentOptions
          open={openOptions}
          setOpen={setOpenOptions}
          coordinates={coordinates}
          labels={{
            name: props.item.name,
            oem: props.item.oem,
            createdDate: new Intl.DateTimeFormat('en-US',{day:'2-digit', month:'2-digit', year:'2-digit'}).format(new Date(props.item.createdDate)),
            userName: props.item.createdBy?.name ? props.item.createdBy.name : "Default User",
            lastEditedDate: new Intl.DateTimeFormat('en-US',{day:'2-digit', month:'2-digit', year:'2-digit'}).format(new Date(props.item.updateDate)),
            organization: props.item.organization,
          }} 
          onActions={handleActions}
          brand={props.item}
          dealerUser={props.dealerUser}
        />
        }
      {/*
        openEdit &&
        <EditDesign
          open = {openEdit}
          setOpen = {setOpenEdit}
          design = {props.item}
          onEditMyDesigns={handleEdit}
        />
      */} 
    </S.Root >
  );
}

export default PreviewComponent;